import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";

function Contact() {
    return (
        <React.Fragment>
            <div className="font-quicksand" data-theme="weireframe">
                <div class="navbar ">
                    <div class="navbar-start">

                    </div>
                    <div class="navbar-center lg:flex">
                        <ul class="menu menu-horizontal p-0">
                            <li className="p-2"><Link to={paths.home}>Home</Link></li>
                            <li><a href="https://herandcomm.com/">Shop</a></li>
                            <li className="p-2"><Link to={paths.about}>About Us</Link></li>
                            <li className="p-2"><Link to={paths.contact}>Contact</Link></li>
                        </ul>
                    </div>
                    <div className="navbar-end"></div>
                </div>
                <div className="py-20 lg:text-center xl:text-center pl-10">
                    <h1 className="text-xl lg:text-4xl xl:text-4xl font-semibold pb-10">Contact Us</h1>
                    <ul className="list-none">
                        <li className="pb-8">
                            <p className="text-lg pt-2 lg:text-xl xl:text-xl">Email:</p>
                            <p className="text-lg pt-2 lg:text-xl xl:text-xl">mermaid.winnie@gmail.com</p>
                        </li>
                        <li className="pb-8">
                            <p className="text-lg pt-2 lg:text-xl xl:text-xl">Facebook:</p>
                            <p className="text-lg pt-2 lg:text-xl xl:text-xl">HER. & CO</p>
                        </li>
                        <li className="pb-8">
                            <p className="text-lg pt-2 lg:text-xl xl:text-xl">Location:</p>
                            <p className="text-lg pt-2 lg:text-xl xl:text-xl">Yangon, Myanmar</p>
                        </li>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Contact;